import { useTenantDropdown } from 'TenantModule/hooks/useTenantDropdown';
import { useCreateTenantSecretMapping } from 'TenantModule/hooks/useCreateTenantSecretMapping';
import { FormEvent, MouseEventHandler, useState } from 'react';
import { useIntegrationAgentsMultiSelector } from 'IntegrationModule/components/IntegrationAgentsMultiSelector/useIntegrationAgentsMultiSelector';

interface CreateTenantSecretMappingFields {
  dbHost: string;
  dbName: string;
  dbPassword: string;
  dbUser: string;
  roHost: string;
}

const tenantSecretMappingDefaultValues = {
  dbHost: '',
  dbName: '',
  dbPassword: '',
  dbUser: '',
  roHost: '',
};

export const useTenantSecretMappingForm = () => {
  const integrationAgentsSelectorProps = useIntegrationAgentsMultiSelector({});
  const [createTenantSecretMappingParams, setCreateTenantSecretMappingParams] =
    useState<CreateTenantSecretMappingFields>(tenantSecretMappingDefaultValues);
  // Secret mappings are onboarding setup — tenants not yet Ready must be selectable.
  const { openTenantDropdown, selectedTenant } = useTenantDropdown({
    allowOnboardingTenants: true,
  });
  const { createTenantSecretMapping, isCreatingTenantSecretMapping } =
    useCreateTenantSecretMapping();

  const onCreateTenantSecretMappingFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setCreateTenantSecretMappingParams({
      ...createTenantSecretMappingParams,
      [name]: value,
    });
  };

  const onTenantSelectorClick: MouseEventHandler<HTMLElement> = (e) => {
    openTenantDropdown({
      target: e.currentTarget,
    });
  };

  const onSubmitCreateTenantSecretMappingForm = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    createTenantSecretMapping({
      services: integrationAgentsSelectorProps.selectedIntegrationAgents,
      secret: {
        credentials: createTenantSecretMappingParams,
      },
      tenant: selectedTenant?.tenantName || '',
    });
  };

  return {
    createTenantSecretMappingParams,
    onCreateTenantSecretMappingFormChange,
    onSubmitCreateTenantSecretMappingForm,
    onTenantSelectorClick,
    integrationAgentsSelectorProps,
    selectedTenant,
    isCreatingTenantSecretMapping,
  };
};
